class VariantUpsells extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.upsells = Array.from(this.querySelectorAll("label[data-variant-id]"));
    this.productContainer = this.closest("product-details") || this.closest("product-form");
    if (!this.productContainer) return;

    this.productContainer.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );

    this.initializeSwiper();
  }
  initializeSwiper() {
    if (this.swiper) {
      this.swiper.destroy();
    }
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      }
    });
  }
  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.upsells.forEach((label) => {
      const input = label.querySelector("input");
      if (input && input.checked) {
        input.checked = false;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
    this.upsells.forEach((label) => {
      label.classList.toggle("hidden", variant.id != label.dataset.variantId);
    });
    this.initializeSwiper();
  }
}
customElements.define("variant-upsells", VariantUpsells);

class BundleComponents extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productForm = this.closest("product-form");
    if (!this.productForm) return;
    this.variantInputs = Array.from(this.querySelectorAll("input[data-parent-variant-id]"));
    this.includeRows = Array.from(this.productForm.querySelectorAll("[data-bundle-include-variant]"));
    this.productForm.addEventListener("variant:change", this.handleVariantChange.bind(this));
  }
  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant) return;
    this.variantInputs.forEach((input) => {
      if (input.dataset.parentVariantId == variant.id) {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    });
    this.includeRows.forEach((row) => {
      row.classList.toggle("is-hidden", row.dataset.parentVariantId != variant.id);
    });
  }
}
customElements.define("bundle-components", BundleComponents);

class UpsellVariantCard extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector("input[type='checkbox']");
    if (!this.checkbox) return;

    this.handleClick = this.handleClick.bind(this);
    this.addEventListener("click", this.handleClick);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }
  handleClick(event) {
    // Don't toggle if clicking on a link
    if (event.target.closest("a")) return;

    this.checkbox.checked = !this.checkbox.checked;
    this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
customElements.define("upsell-variant-card", UpsellVariantCard);

class CustomScreenRequestForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.body = this.querySelector("[data-quote-body]");
    this.areaDisplay = this.querySelector("[data-total-area]");
    this.qtyInput = this.querySelector("[data-qty-input]");
    this.qtyMinus = this.querySelector("[data-qty-minus]");
    this.qtyPlus = this.querySelector("[data-qty-plus]");
    this.dimensionInputs = this.querySelectorAll("[data-dimension]");
    this.lastAreaSqM = 0;

    this._onDimensionInput = () => this.updateArea();
    this.dimensionInputs.forEach((input) =>
      input.addEventListener("input", this._onDimensionInput)
    );

    this._onQtyMinus = () => this.handleQuantityChange(-1);
    this._onQtyPlus = () => this.handleQuantityChange(1);
    this.qtyMinus.addEventListener("click", this._onQtyMinus);
    this.qtyPlus.addEventListener("click", this._onQtyPlus);

    this._onSubmit = (e) => this.handleSubmit(e);
    this.form.addEventListener("submit", this._onSubmit);
  }

  disconnectedCallback() {
    this.dimensionInputs.forEach((input) =>
      input.removeEventListener("input", this._onDimensionInput)
    );
    this.qtyMinus.removeEventListener("click", this._onQtyMinus);
    this.qtyPlus.removeEventListener("click", this._onQtyPlus);
    this.form.removeEventListener("submit", this._onSubmit);
  }

  updateArea() {
    const widthM = (parseFloat(this.querySelector('[name="width_cm"]').value) || 0) / 100;
    const heightM = (parseFloat(this.querySelector('[name="height_cm"]').value) || 0) / 100;
    this.lastAreaSqM = widthM * heightM;

    if (this.lastAreaSqM > 0) {
      this.areaDisplay.textContent = this.lastAreaSqM.toFixed(2);
    } else {
      this.areaDisplay.textContent = "\u2014";
    }
  }

  handleQuantityChange(delta) {
    const current = parseInt(this.qtyInput.value) || 1;
    const next = Math.max(1, current + delta);
    this.qtyInput.value = next;
  }

  handleSubmit(event) {
    const wCm = this.querySelector('[name="width_cm"]').value || "0";
    const hCm = this.querySelector('[name="height_cm"]').value || "0";
    const qty = this.qtyInput.value;

    this.body.value =
      "Product: " + this.dataset.productTitle +
      "\nURL: " + window.location.origin + this.dataset.productUrl +
      "\nWidth: " + wCm + " cm" +
      "\nHeight: " + hCm + " cm" +
      "\nTotal Area: " + this.areaDisplay.textContent + " sq m" +
      "\nQuantity: " + qty;
  }
}
customElements.define("custom-screen-request-form", CustomScreenRequestForm);

class HeaderSearchBar extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-header-search-input]");
    if (!this.input) return;

    this._onFocus = () => this.openSearchOverlay();
    this._onInput = () => this.syncOverlayInput();

    this.input.addEventListener("focus", this._onFocus);
    this.input.addEventListener("input", this._onInput);
  }

  disconnectedCallback() {
    this.input?.removeEventListener("focus", this._onFocus);
    this.input?.removeEventListener("input", this._onInput);
  }

  openSearchOverlay() {
    const modal = document.querySelector('modal-component[data-type="search-overlay"]');
    if (!modal?.classList.contains("is-active")) {
      window.dispatchEvent(
        new CustomEvent("modal-toggle", { detail: { type: "search-overlay" } })
      );
    }

    window.setTimeout(() => this.syncOverlayInput(true), 150);
  }

  syncOverlayInput(shouldSearch = false) {
    const modal = document.querySelector('modal-component[data-type="search-overlay"]');
    const overlayInput = document.querySelector(
      'search-overlay [data-search-input]'
    );

    if (!modal?.classList.contains("is-active") || !overlayInput) return;

    overlayInput.value = this.input.value;

    if (shouldSearch || this.input.value.length) {
      overlayInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }
}
customElements.define("header-search-bar", HeaderSearchBar);

